<div class="container">
	<div class="row rightcomponent">
		<div class="" [dir]="currentDirection">
			<p>Visitor, welcome to Neverume.com. This Agreement governs the
				use of our portal. By using our service, you agree to comply with
				all the terms outlined in this Agreement.</p>

			<h4>1. Acceptance of Terms</h4>
			<p>By registering, you confirm that you have read, understood,
				and agree to the terms of this Agreement. We may update the terms
				from time to time, and you are required to periodically review this
				page for any changes.</p>

			<h4>2. Visitor, account holder conduct</h4>
			<p>Prohibited Actions:</p>
			<ul>
				<li>Promoting, recording pornographic materials in accordance
					with widely accepted moral, ethical, and legal Iceland norms.</li>
				<li>Focusing visitors attention on sex and sexual context.</li>
				<li>Using the service to conceal or encourage illegal
					activities.</li>
				<li>Sharing content that enables the transmission of malware or
					violates human rights.</li>
				<li>Drawing undue attention to sensitive content.</li>
				<li>Forcing users to view materials containing sensitive
					content.</li>
				<li>Promoting drugs and other prohibited substances.</li>
				<li>Engaging in any activities that cause harm to health and
					violate current legislation.</li>
			</ul>
			<p>Use of Service: You may use media-portal only for lawful
				purposes and in accordance with the terms of this Agreement. You may
				upload videos, photos, audio, comments, and other content. To avoid
				misunderstandings, when uploading sensitive content, you need
				correctly, timely, promptly give know visitors they was can will
				view or will find such content.</p>


			<h4>3. Confidetiality</h4>
			<p>Data Collection and Use: We collect information necessary to
				provide and improve our service. This may include, but is not
				limited to, personal information such as your name and email
				address.</p>
			<p>Security: We take reasonable measures to protect your data but
				cannot guarantee absolute security.</p>
			<p>User Rights: You have the right to access your personal data.</p>

			<h4>4. Limitation of Liability</h4>
			<p>Disclaimer of Liability: The portal allows users to upload
				media, videos, audio, photos, and comments and is provided on an
				"as-is" and "as-available" basis. We are not responsible for any
				damage arising from the use or inability to use the portal,
				including, but not limited to, indirect, incidental, or punitive
				damages.</p>
			<p>Indemnification: You agree to promptly cease any activities
				that violate the terms of this Agreement and to indemnify us for any
				losses or expenses incurred as a result of your breach of these
				terms.</p>
		</div>
	</div>
</div>